import axiosInstance, { getUserData } from "./http-server";

import ConfigData from "../Config/index.json";

type ConfigType = typeof ConfigData;
type TenantKey = keyof ConfigType;

const adminUrl = process.env.REACT_APP_ADMIN_URL;
const authUrl = process.env.REACT_APP_AUTH_URL;
const getSelectedTenant = (): TenantKey | undefined => {
  return getUserData()?.current_tenant_name as TenantKey;
};

const getBaseUrl = (): string | undefined => {
  const tenant = getSelectedTenant();
  return tenant ? ConfigData[tenant]?.api : undefined;
};

const get = (url: string, signal?: AbortSignal) => {
  const baseUrl = getBaseUrl();
  if (!baseUrl) throw new Error("Base URL not set. User data may be missing.");
  return axiosInstance.get(baseUrl + `${url}`, { signal });
};
const getAuth = (url: string, signal?: AbortSignal) => {
  return axiosInstance.get(authUrl + `${url}`, { signal });
};
const getAdmin = (url: string, signal?: AbortSignal) => {
  return axiosInstance.get(adminUrl + `${url}`, { signal });
};
const deleteData = (url: string) => {
  const baseUrl = getBaseUrl();
  if (!baseUrl) throw new Error("Base URL not set. User data may be missing.");
  return axiosInstance.delete(baseUrl + `${url}`, {});
};

const post = (url: string, data: any) => {
  const baseUrl = getBaseUrl();
  if (!baseUrl) throw new Error("Base URL not set. User data may be missing.");
  return axiosInstance.post(baseUrl + url, data);
};
const postAuth = (url: string, data: any) => {
  return axiosInstance.post(authUrl + url, data);
};

const patch = (url: string, data: any) => {
  const baseUrl = getBaseUrl();
  if (!baseUrl) throw new Error("Base URL not set. User data may be missing.");
  return axiosInstance.patch(baseUrl + url, data);
};
const postImage = (url: string, data: any) => {
  const baseUrl = getBaseUrl();
  if (!baseUrl) throw new Error("Base URL not set. User data may be missing.");
  return axiosInstance.post(baseUrl + url, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
const postdoc = (url: string, data: any) => {
  const baseUrl = getBaseUrl();
  if (!baseUrl) throw new Error("Base URL not set. User data may be missing.");
  return axiosInstance.post(baseUrl + url, data, {
    responseType: "blob",
  });
};

const HttpService = {
  get,
  deleteData,
  patch,
  postImage,
  postdoc,
  post,
  postAuth,
  getAuth,
  getAdmin,
};

export default HttpService;
